import { render, staticRenderFns } from "./ExtraCoverage.vue?vue&type=template&id=49d765e2&scoped=true"
import script from "./ExtraCoverage.vue?vue&type=script&lang=js"
export * from "./ExtraCoverage.vue?vue&type=script&lang=js"
import style0 from "./ExtraCoverage.vue?vue&type=style&index=0&id=49d765e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d765e2",
  null
  
)

export default component.exports